import { App } from 'vue';
import { VueReCaptcha } from 'vue-recaptcha-v3';

export default (app: App<Element>): App<Element> =>
  app.use(VueReCaptcha, {
    siteKey: import.meta.env.VITE_RECAPTCHA_SITE_KEY,
    loaderOptions: {
      autoHideBadge: true,
    },
  });

export { VueReCaptcha };
